export const APP_MOBILE_MENU_OPEN = 'APP_MOBILE_MENU_OPEN';
export const APP_MOBILE_MENU_CLOSE = 'APP_MOBILE_MENU_CLOSE';
export const APP_MOBILE_MENU_TOGGLE = 'APP_MOBILE_MENU_TOGGLE';
export const APP_TOPNAV_MENU_OPEN = 'APP_TOPNAV_MENU_OPEN';
export const APP_TOPNAV_MENU_CLOSE = 'APP_TOPNAV_MENU_CLOSE';
export const APP_SET_READY = 'APP_SET_READY';
export const APP_SET_READY_ERROR = 'APP_SET_READY_ERROR';
export const APP_SET_CORE = 'APP_SET_CORE';
export const APP_CHANGE_PAGE = 'APP_CHANGE_PAGE';
export const APP_CHANGE_BREAKPOINT = 'APP_CHANGE_BREAKPOINT';

export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const SET_TEST_FLIGHT_PAGE = 'SET_TEST_FLIGHT_PAGE';
export const SET_TEST_FLIGHT_PAGE_PARAMS = 'SET_TEST_FLIGHT_PAGE_PARAMS';
export const SET_TEST_FLIGHT_COMPONENTS_BUILDING = 'SET_TEST_FLIGHT_COMPONENTS_BUILDING';

export const SET_GRID_WITH_SIDE_PREVIEW = 'SET_GRID_WITH_SIDE_PREVIEW';

export const SET_CLIENT_DATA = 'SET_CLIENT_DATA';
export const MANUAL_UPDATE_CLIENT_DATA = 'MANUAL_UPDATE_CLIENT_DATA';

export const USER_AUTH_LOADING_START = 'USER_AUTH_LOADING_START';
export const USER_AUTH_LOADING_END = 'USER_AUTH_LOADING_END';

export const SET_USER_IS_ONLINE = 'SET_USER_IS_ONLINE';
export const SET_USER_IS_OFFLINE = 'SET_USER_IS_OFFLINE';

export const SET_MY_NETWORKING = 'SET_MY_NETWORKING';
export const FORCE_CLOSE_SPLASH_SCREEN = 'FORCE_CLOSE_SPLASH_SCREEN';
export const SET_LAYER = 'SET_LAYER';

export const SET_VOUCHER = 'SET_VOUCHER';
export const LOCK_CONTENT = 'LOCK_CONTENT';
export const UNLOCK_CONTENT = 'UNLOCK_CONTENT';

export const SET_FRESH_CHAT_READY = 'SET_FRESH_CHAT_READY';
export const SET_ADMIN_CLIENT_PREVIEW = 'SET_ADMIN_CLIENT_PREVIEW';
export const ENABLE_SCREEN_SAVER = 'ENABLE_SCREEN_SAVER';
export const DISABLE_SCREEN_SAVER = 'DISABLE_SCREEN_SAVER';
